"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Nav = _interopRequireDefault(require("./components/Nav"));
var _CategoryPhotos = _interopRequireDefault(require("./components/CategoryPhotos"));
var _helpers = require("./helpers");
var _constants = require("./constants");
var _withGalleryProps = _interopRequireDefault(require("./withGalleryProps"));
var _arrow = _interopRequireDefault(require("./components/Nav/arrow.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var GalleryModal = function GalleryModal(_ref) {
  var categories = _ref.categories,
    photos = _ref.photos,
    photosByCaregories = _ref.photosByCaregories,
    _onClose = _ref.onClose,
    onClickByPhoto = _ref.onClickByPhoto;
  var _useState = (0, _react.useState)((0, _helpers.createSizesPlaceholder)(photos)),
    _useState2 = _slicedToArray(_useState, 2),
    sizes = _useState2[0],
    setSizes = _useState2[1];
  var _useState3 = (0, _react.useState)(R.path([0, 'id'], categories)),
    _useState4 = _slicedToArray(_useState3, 2),
    activeCategoryID = _useState4[0],
    setActiveCategoryID = _useState4[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var isReady = (0, _react.useMemo)(function () {
    return R.equals(photos.length, R.call(R.pipe(R.filter(Boolean), R.length), sizes));
  }, [photos.length, sizes]);
  var groups = (0, _react.useMemo)(function () {
    return isReady ? R.isEmpty(photosByCaregories) ? R.call(R.pipe(R.map(function (src) {
      return _objectSpread({
        src: src
      }, sizes[R.indexOf(src, photos)]);
    }), _helpers.createPhotosGroupsNext), photos) : R.map(R.over(R.lensProp('photos'), R.pipe(R.map(function (photo) {
      return R.mergeAll([{
        src: photo
      }, sizes[R.indexOf(photo, photos)]]);
    }), _helpers.createPhotosGroupsNext)), photosByCaregories) : [];
  }, [isReady, photosByCaregories, photos, sizes]);
  (0, _react.useEffect)(function () {
    R.call(R.pipe(R.map(_helpers.toImageEntity), R.addIndex(R.forEach)(function (img, index) {
      return img.onload = function () {
        return setSizes(function (prevSizes) {
          return R.set(R.lensIndex(index), {
            height: img.height,
            width: img.width
          }, prevSizes);
        });
      };
    })), photos);
  }, [photos]);
  (0, _react.useEffect)(function () {
    var body = global.document.querySelector('body');
    body.classList.add(_styles.default.disabledDimmer);
    return function () {
      return body.classList.remove(_styles.default.disabledDimmer);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isReady) {
      global.document.getElementById(_constants.CATEGORIES_PHOTOS_BLOCK_ID).focus();
    }
  }, [isReady]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    className: _styles.default.galleryModal,
    id: _styles.default.galleryModalID,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: _styles.default.header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.goBack,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    },
    onClick: function onClick() {
      return _onClose();
    }
  }), t('GALLERY_PHOTOS_MODAL_TITLE', {
    photosCount: photos.length
  })), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _styles.default.content
  }, !R.isEmpty(categories) && /*#__PURE__*/_react.default.createElement(_Nav.default, {
    activeCategoryID: activeCategoryID,
    categories: categories,
    onCategoryChange: _helpers.scrollToCategoryPhotosBlock
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.listWrapper,
    id: _constants.CATEGORIES_PHOTOS_BLOCK_ID
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, R.isEmpty(photosByCaregories) ? R.map(function (group) {
    var renderFunc = _constants.STRATEGIES_RENDERING_GROUPS[group.strategyIndex];
    return renderFunc(group.photos, onClickByPhoto);
  }, groups) : R.map(function (_ref2) {
    var category = _ref2.category,
      groupPhotos = _ref2.photos;
    return /*#__PURE__*/_react.default.createElement(_CategoryPhotos.default, {
      id: category.id,
      isFirst: R.head(groups).category === category,
      isLast: R.last(groups).category === category,
      key: category.id,
      name: category.name,
      onIntersection: function onIntersection() {
        return setActiveCategoryID(category.id);
      }
    }, R.map(function (group) {
      var renderFunc = _constants.STRATEGIES_RENDERING_GROUPS[group.strategyIndex];
      return renderFunc(group.photos, onClickByPhoto);
    }, groupPhotos));
  }, groups)))));
};
GalleryModal.propTypes = {
  onClose: _propTypes.default.func.isRequired
};
var enhancer = R.compose(_withGalleryProps.default, _react.memo);
var _default = exports.default = enhancer(GalleryModal);